import moment from 'moment'
import 'moment/locale/ru'

const CARGO_READINESS_PARSE_FORMATS = [
  'YYYY-MM-DDTHH:mm:ss.SSSSSS',
  'YYYY-MM-DDTHH:mm:ss',
  'YYYY-MM-DDTHH:mm',
  'YYYY-MM-DD HH:mm:ss',
  'YYYY-MM-DD HH:mm',
  'YYYY-MM-DD',
  'DD.MM.YYYY HH:mm:ss',
  'DD.MM.YYYY HH:mm',
  'DD.MM.YYYY',
  moment.ISO_8601,
]

export function parseCargoReadinessMoment(
  value?: string | null
): moment.Moment | null {
  const trimmed = value?.trim() ?? ''
  if (!trimmed) return null
  const strict = moment(trimmed, CARGO_READINESS_PARSE_FORMATS, true)
  if (strict.isValid()) return strict
  const loose = moment(trimmed)
  return loose.isValid() ? loose : null
}

export function parseCargoReadyForPickup(value: unknown): boolean {
  return value === true || value === 1 || value === '1'
}

export function parseCargoIsPaid(value: unknown): boolean {
  return value === true || value === 1 || value === '1'
}

export function cargoReadinessAtToPickerValue(value?: string | null): string {
  const m = parseCargoReadinessMoment(value)
  return m ? m.format('YYYY-MM-DD HH:mm') : ''
}

const capitalizeWord = (part: string) => {
  const trimmed = part.replace(/\./g, '').trim()
  if (!trimmed) return ''
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1)
}

export function formatCargoReadinessListDate(value?: string | null): string {
  const m = parseCargoReadinessMoment(value)
  if (!m) return ''
  const ru = m.locale('ru')
  const day = ru.format('DD')
  const month = capitalizeWord(ru.format('MMM'))
  const weekday = capitalizeWord(ru.format('ddd'))
  const time = ru.format('HH:mm')
  return `${day} ${month}, ${weekday} ${time}`
}
